<template>
	<v-row>
		<v-col cols="12" lg="4">
			<practice-dashboard-main />
		</v-col>

		<v-col class="stickycomponent" cols="12" lg="8">
			<div v-if="$vuetify.breakpoint.width >= 1264">
				<practice-dashboard-big-calendar />
			</div>
		</v-col>
		<feature-explorer ref="featureDialog"></feature-explorer>
	</v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import PracticeDashboardMain from '@/components/ui/dashboard/practice/PracticeDashboardMain';
import PracticeDashboardBigCalendar from '@/components/ui/dashboard/practice/PracticeDashboardBigCalendar';
import FeatureExplorer from '@/components/custom/FeatureExplorer';

export default {
	name: 'PracticeDashboard',
	components: {
		PracticeDashboardMain,
		PracticeDashboardBigCalendar,
		FeatureExplorer,
	},
	data: () => ({}),
	computed: {
		...mapGetters(['company', 'user']),
	},
	async mounted() {
		const featureViewedDate = localStorage.getItem('featureViewedDate');
		const feature = await this.$refs.featureDialog.loadFeatures();

		if (!feature || !feature.active) return;

		if (featureViewedDate) {
			if (featureViewedDate < feature.startDate) {
				this.$refs.featureDialog.open();
			}
		} else {
			this.$refs.featureDialog.open();
		}
	},
};
</script>

<style>
* {
	text-transform: none !important;
}
</style>
